<div class="SLV2-prctcs-testcard-box">
    <img class="SLV2-prctcs-testcard-title" src="selflearnv2-ui/assets/img/self-learn-v2/practice-test-title.svg" />

    <button class="SLV2-prctcs-testcard-lock-text"><img class="lock-icon" src="selflearnv2-ui/assets/img/self-learn-v2/lock-red-icon.svg" />Locked</button>
    <button class="SLV2-prctcs-testcard-lock-text unlock" *ngIf="false"><img class="lock-icon" src="selflearnv2-ui/assets/img/self-learn-v2/lock-green-icon.svg" />Unlocked</button>

    <p class="SLV2-prctcs-testcard-text">Achieve 50% of chapter progress to unlock this test</p>

    <button class="SLV2-prctcs-solid-button" *ngIf="false">Attempt now</button>
</div>
